import { COMPETITION, LAYOUT } from "./lib/types/scoutingSheetConfigTypes";

export const events: COMPETITION[] = [
    {
        "name": "Bordie Blast 2025",
        "teams": [360, 492, 948, 949, 1294, 1318, 1778, 1899, 1983, 2122, 2412, 2522, 2557, 2910, 2928, 2930, 2976, 2990, 3070, 3218, 3663, 3681, 4089, 4131, 4911, 5683, 5937, 6390, 7461, 7627, 9023, 9036, 9450, 9973, 9998, 9999, 10079]
    },
    {
        "name": "Test Event",
        "teams": [1778]
    }
];

export const layouts: LAYOUT[] = [
    {
        "name": "Pit Scout",
        "type": "pit",
        "sheets": [
            {
                "name": "Main",
                "default": true,
                "components": [
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "TextEntry",
                                "tag": "data|weight",
                                "props": {
                                    "label": "Robot Weight, No B&B",
                                    "placeholder": "(No Bumpers)",
                                    "width": "50vw",
                                    "height": "10vh"
                                }
                            },
                            {
                                "type": "TextEntry",
                                "tag": "data|driver experience",
                                "props": {
                                    "label": "Driver # of Comps",
                                    "placeholder": "(# of comps)",
                                    "width": "50vw",
                                    "height": "10vh"
                                }
                            },
                        ],
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "TextEntry",
                                "tag": "data|drivetrain",
                                "props": {
                                    "label": "Drivetrain Type",
                                    "placeholder": "Swerve/Tank/Etc.",
                                    "width": "50vw",
                                    "height": "10vh"
                                }
                            },
                            {
                                "type": "TextEntry",
                                "tag": "data|drive motors",
                                "props": {
                                    "label": "Drive Motors + Ratio",
                                    "placeholder": "Ex. L3/Krakens",
                                    "width": "50vw",
                                    "height": "10vh"
                                }
                            },
                        ],
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "TextEntry",
                                "tag": "data|tiaras",
                                "props": {
                                    "label": "Does the team have tieras?",
                                    "placeholder": "Yes/No",
                                    "width": "100vw",
                                    "height": "10vh"
                                }
                            }
                        ],
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "TextEntry",
                                "tag": "data|intake",
                                "props": {
                                    "label": "Intake Type and Width",
                                    "placeholder": "Ground/Feeder, Full width/Center",
                                    "width": "100vw",
                                    "height": "10vh"
                                }
                            },
                        ],
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "TextEntry",
                                "tag": "data|strength",
                                "props": {
                                    "label": "Biggest Strength",
                                    "placeholder": "",
                                    "width": "100vw",
                                    "height": "10vh"
                                }
                            },
                        ],
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "TextEntry",
                                "tag": "data|issues",
                                "props": {
                                    "label": "Current Issues",
                                    "placeholder": "",
                                    "width": "50vw",
                                    "height": "10vh"
                                }
                            },
                            {
                                "type": "TextEntry",
                                "tag": "data|notes",
                                "props": {
                                    "label": "Notes",
                                    "placeholder": "",
                                    "width": "50vw",
                                    "height": "10vh"
                                }
                            },
                        ],
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "OverlaySelection",
                                "tag": "data|scoring height",
                                "props": {
                                    "label": "Max Coral Scoring Height",
                                    "width": "50vw",
                                    "height": "15vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": ["Level 4 (Highest)", "Level 3", "Level 2", "Level 1 (Lowest)", "Cannot scL"]
                                }
                            },
                            {
                                "type": "OverlaySelection",
                                "tag": "data|climbing",
                                "props": {
                                    "label": "Climbing Ability",
                                    "width": "50vw",
                                    "height": "15vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": ["Shallow", "Deep", "Can't climb"]
                                }
                            },
                        ],
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "right"
                        },
                        "children": [
                            {
                                "type": "OverlaySelection",
                                "tag": "data|algae scoring",
                                "props": {
                                    "label": "Algae Scoring Ability",
                                    "width": "50vw",
                                    "height": "15vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": ["Barge (High)", "Processor (Ground Slot)", "No Algae"]
                                }
                            },
                            {
                                "type": "Button",
                                "tag": "submit",
                                "props": {
                                    "label": "Submit",
                                    "width": "50vw",
                                    "height": "15vh",
                                    "color": "blue",
                                }
                            },
                        ],
                    },
                ]
            }
        ]
    },
    {
        "name": "Match Scout",
        "type": "match",
        "sheets": [
            {
                "name": "Auto",
                "default": true,
                "components": [
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                children: [
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|acL4|0",
                                        "props": {

                                            "label": "Coral Scored L4",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|acL3|0",
                                        "props": {

                                            "label": "Coral Scored L3",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|acL2|0",
                                        "props": {

                                            "label": "Coral Scored L2",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|acL1|0",
                                        "props": {

                                            "label": "Coral Scored L1",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    }
                                ]
                            },
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                children: [
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|adcL4|0",
                                        "props": {

                                            "label": "Coral Dropped L4",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|adcL3|0",
                                        "props": {

                                            "label": "Coral Dropped L3",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|adcL2|0",
                                        "props": {

                                            "label": "Coral Dropped L2",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|adcL1|0",
                                        "props": {

                                            "label": "Coral Dropped L1",
                                            "width": "50vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                children: [
                                    {
                                        "type": "Button",
                                        "tag": "switch|Endgame",
                                        "props": {
                                            "label": "Endgame Tab",
                                            "width": "50vw",
                                            "height": "10vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "Button",
                                        "tag": "switch|Teleop",
                                        "props": {
                                            "label": "Teleop Tab",
                                            "width": "50vw",
                                            "height": "10vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },

                                ],
                            },
                            {
                                "type": "OverlaySelection",
                                "tag": "data|Auto Side",
                                "props": {
                                    "label": "Auto Start Side",
                                    "width": "50vw",
                                    "height": "20vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": ["processor side", "center", "non-processor side"]
                                }
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Teleop",
                "components": [
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                children: [
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|scL4|0",
                                        "props": {

                                            "label": "Coral Scored L4",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|scL3|0",
                                        "props": {

                                            "label": "Coral Scored L3",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|scL2|0",
                                        "props": {

                                            "label": "Coral Scored L2",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|scL1|0",
                                        "props": {

                                            "label": "Coral Scored L1",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    }
                                ]
                            },
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                children: [
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|dcL4|0",
                                        "props": {

                                            "label": "Coral Dropped L4",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|dcL3|0",
                                        "props": {

                                            "label": "Coral Dropped L3",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|dcL2|0",
                                        "props": {

                                            "label": "Coral Dropped L2",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|dcL1|0",
                                        "props": {

                                            "label": "Coral Dropped L1",
                                            "width": "33.3vw",
                                            "height": "17.5vh",
                                            "color": "red",
                                            "pressColor": "darkred"
                                        }
                                    }
                                ]
                            },
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                "children": [        
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|score barge|0",
                                        "props": {
                                            "label": "Barge Algae",
                                            "width": "33.3vw",
                                            "height": "35vh",
                                            "vertical": true,
                                            "color": "green",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "CounterButton",
                                        "tag": "data|score slot|0",
                                        "props": {
                                            "label": "Processor Algae",
                                            "width": "33.3vw",
                                            "height": "35vh",
                                            "vertical": true,
                                            "color": "green",
                                            "pressColor": "darkblue"
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                children: [
                                    {
                                        "type": "Button",
                                        "tag": "switch|Auto",
                                        "props": {
                                            "label": "Auto Tab",
                                            "width": "50vw",
                                            "height": "10vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "Button",
                                        "tag": "switch|Endgame",
                                        "props": {
                                            "label": "Endgame Tab",
                                            "width": "50vw",
                                            "height": "10vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },

                                ],
                            }
                        ]
                    }
                ]
            },
            {
                "name": "Endgame",
                "components": [
                    {
                        "type": "Empty",
                        "props": {
                            "height": "vh"
                        }
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "OverlaySelection",
                                "tag": "data|intake type",
                                "props": {
                                    "label": "Coral Intake Type",
                                    "width": "50vw",
                                    "height": "20vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": ["Ground Intake", "Source Only Intake", "Doesn't Intake Coral"]
                                }
                            }
                        ]
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "OverlaySelection",
                                "tag": "data|climb",
                                "props": {
                                    "label": "Climb?",
                                    "width": "50vw",
                                    "height": "20vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": [["Climbed Deep Cage :)", "Failed Deep Cage :( "], ["Climbed Shallow Cage :) ", "Failed Shallow Cage :("], ["Parked :| ", "Nothing :( "]]
                                }
                            },
                            {
                                "type": "OverlaySelection",
                                "tag": "data|defense",
                                "props": {
                                    "label": "Defense?",
                                    "width": "50vw",
                                    "height": "20vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": ["A lot", "Some", "None"]
                                }
                            }
                        ]
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "OverlaySelection",
                                "tag": "data|broken",
                                "props": {
                                    "label": "Broken?",
                                    "width": "50vw",
                                    "height": "20vh",
                                    "backgroundColor": "blue",
                                    "buttonColor": "blue",
                                    "choices": [["Slower Scoring", "Cannot Score"], ["Slower Moving", "Cannot Move"], ["Stuck On Algae", "Broken | Misc"], "None"]
                                }
                            },
                            {
                                "type": "TextEntry",
                                "tag": "data|notes",
                                "props": {
                                    "label": "Notes",
                                    "placeholder": "Optional, but helpful",
                                    "width": "50vw",
                                    "height": "20vh",
                                }
                            }
                        ]
                    },
                    {
                        "type": "Row",
                        "props": {
                            "alignment": "left"
                        },
                        children: [
                            {
                                "type": "Column",
                                "props": {
                                    "alignment": "top"
                                },
                                children: [
                                    {
                                        "type": "Button",
                                        "tag": "switch|Teleop",
                                        "props": {
                                            "label": "Teleop Tab",
                                            "width": "50vw",
                                            "height": "10vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },
                                    {
                                        "type": "Button",
                                        "tag": "switch|Auto",
                                        "props": {
                                            "label": "Auto Tab",
                                            "width": "50vw",
                                            "height": "10vh",
                                            "color": "blue",
                                            "pressColor": "darkblue"
                                        }
                                    },

                                ],
                            },
                            {
                                "type": "Button",
                                "tag": "submit",
                                "props": {
                                    "label": "Submit",
                                    "width": "50vw",
                                    "height": "20vh",
                                    "color": "blue"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
]
